import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import TitleRow, { TitleAction } from "../../../../shared/components/TitleRow";
import CancelModal from "../../../../shared/components/CancelModal";
import {
    DetailProviderTitleBar,
    DeleteProviderModal,
} from "../../../../configs/provider";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";

interface TitleProps {
    title: string;
    deleteProvider: Function;
    handleSubmit: Function;
    setValidated: Function;
    onDataChange?: () => void;
    hasUnsavedChanges?: boolean;
    onCancelClick?: () => void;
    isSaving?: boolean;
    isDeleting?: boolean;
}

const Title = ({
    title,
    setValidated,
    deleteProvider,
    handleSubmit,
    onDataChange,
    hasUnsavedChanges,
    onCancelClick,
    isSaving = false,
    isDeleting = false,
}: TitleProps) => {
    const navigate = useNavigate();
    const handleCancel = () => {
        if (onDataChange) {
            onDataChange();
        }

        if (onCancelClick && hasUnsavedChanges) {
            onCancelClick();
        } else {
            setIsOpenCancelModal(true);
        }
    };
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF].includes(role);

    const [isOpenCancelModal, setIsOpenCancelModal] = useState(false);
    const titleActions: TitleAction[] = [
        {
            title: DetailProviderTitleBar.deleteButton,
            onClick: () => handleCancel(),
        },
        {
            title: DetailProviderTitleBar.saveButton,
            variant: "contained",
            isLoading: isSaving,
            onClick: () => {
                if (isSaving) return;
                setValidated(true);
                handleSubmit();
            },
        },
    ];

    const getTitleActions = () => {
        return canEdit ? titleActions : [];
    };

    const handleConfirmDelete = async () => {
        await deleteProvider();
        setIsOpenCancelModal(false);
        navigate("/providers/");
    };

    return (
        <>
            <TitleRow title={title} actions={getTitleActions()} />
            {isOpenCancelModal && (
                <CancelModal
                    open={isOpenCancelModal}
                    title={DeleteProviderModal.title}
                    contentText={DeleteProviderModal.context}
                    handleConfirm={handleConfirmDelete}
                    handleClose={() => setIsOpenCancelModal(false)}
                    isLoading={isDeleting}
                />
            )}
        </>
    );
};

export default Title;
